import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { isResearchManager } from "config/constants";
import { routes } from "config/routes";
import * as signInSelectors from "store/selectors/signIn";

interface IReviewerOnlyProps {
  children: JSX.Element;
}

export const ReviewerOnly = ({ children }: IReviewerOnlyProps) => {
  const userInfo = useSelector(signInSelectors.userInfo);

  if (!userInfo.id) return null;

  return isResearchManager(userInfo.roles, userInfo.researchStaffLevel) ? (
    children
  ) : (
    <Navigate to={routes.private.properties} replace />
  );
};
